import linkIndex from './Links';

export default {
  body: 'Blog',
  title: 'Blog',
  links: {
    primary: ['home', 'blog', 'trinkets'],
    trinkets: ['classProject', 'hackAThon', 'demoDay'],
  },
  linkIndex,
};
